import React, { useEffect, useState } from 'react';
import { Star, Check, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const [viewers, setViewers] = useState(100);
  useEffect(() => {
    const startViewerCount = () => {
      let count = Math.floor(Math.random() * (120 - 80 + 1) + 80);
      setViewers(count);
      const interval = setInterval(() => {
        let increment = Math.floor(Math.random() * 3) - 1;
        count += increment;
        if (count < 60) count = 60;
        setViewers(count);
      }, 4500);
      return interval;
    };
    const interval = startViewerCount();
    return () => clearInterval(interval);
  }, []);
  return <section className="bg-[#1A1035] text-white py-[60px] px-[15px] relative overflow-hidden" id="elige-tu-plan" data-id="element-193">
      {/* Background Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#7C3AED] opacity-10 rounded-full blur-[120px] pointer-events-none" data-id="element-194"></div>

      <div className="container max-w-[1000px] mx-auto px-[15px] relative z-10" data-id="element-195">
        <h2 className="text-[28px] sm:text-[32px] text-center mb-[15px] font-[800] text-white font-['Montserrat']" data-id="element-196">
          Accede a "El Apoyo Incondicional"
        </h2>
        <p className="text-center text-[#D1D5DB] mx-auto mb-[40px] max-w-[600px] text-[16px]" data-id="element-197">
          No lo hagas por ti. Hazlo por él. Hazlo por ella. <br data-id="element-198" />
          Hazlo porque todavía estás a tiempo.
        </p>

        <div className="flex justify-center max-w-[500px] mx-auto" data-id="element-199">
          <div className="border-[2px] border-[#7C3AED] bg-[#2D1B69]/80 backdrop-blur-md p-[30px] rounded-[20px] text-center w-full shadow-[0_0_40px_rgba(124,58,237,0.2)] relative" data-id="element-200">
            {/* Badge */}
            <div className="absolute top-[-15px] left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#D4A017] to-[#F59E0B] text-[#1A1035] px-[20px] py-[6px] rounded-[50px] font-bold text-[13px] uppercase shadow-lg flex items-center gap-1 whitespace-nowrap" data-id="element-201">
              <Star size={14} fill="currentColor" data-id="element-202" /> OFERTA LIMITADA
            </div>

            <h3 className="text-[24px] text-white font-[700] font-['Montserrat'] mt-[10px] mb-[5px]" data-id="element-203">
              El Apoyo Incondicional
            </h3>

            <div className="my-[20px] flex items-center justify-center gap-3" data-id="element-204">
              <div className="text-[20px] line-through text-[#6B7280]" data-id="element-205">
                $19.99
              </div>
              <div className="text-[48px] text-[#D4A017] font-[800] leading-none" data-id="element-206">
                $7.77
              </div>
            </div>

            <ul className="text-left space-y-3 mb-[30px] max-w-[300px] mx-auto" data-id="element-207">
              <li className="flex items-start gap-2 text-[14px] text-[#E5E7EB]" data-id="element-208">
                <Check className="text-[#059669] shrink-0 mt-0.5" size={18} data-id="element-209" />
                <span data-id="element-210">Descarga inmediata (PDF)</span>
              </li>
            </ul>

            <a href="https://oriammarketing.com/cart/45555442090182:1" onClick={() => trackAddToCart()} className="block w-full bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white border-none p-[18px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(124,58,237,0.4)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_12px_30px_rgba(124,58,237,0.6)] transition-all duration-400" data-id="element-211">
              👉 DESCARGAR POR $7.77
            </a>

            <p className="text-[#9CA3AF] text-[11px] mt-[15px]" data-id="element-212">
              Pago único · Acceso de por vida · Seguro y Privado
            </p>
          </div>
        </div>

        <div className="max-w-[500px] mx-auto mt-[30px] flex flex-col gap-[12px]" data-id="element-213">
          <div className="bg-[#2D1B69] text-white font-[700] p-[12px] rounded-[8px] text-[15px] text-center border border-[#7C3AED]/30" data-id="element-214">
            <strong data-id="element-215">
              <span className="viewer-count text-[#A78BFA]" data-id="element-216">{viewers}</span>{' '}
              personas
            </strong>{' '}
            están considerando esta guía ahora
          </div>
        </div>
      </div>
    </section>;
}